import { Popover, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { Fragment, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { NavLink } from 'react-router-dom';

const Menu_Popover = (props) =>{

    const popover = useRef();

    const { t } = useTranslation();

    return(
        <Popover className="relative">
            {({ open }) => (
            <>
                <Popover.Button
                    ref={popover}
                    className={'text-base font-medium text-gray-500 hover:text-slate-900 inline-flex items-center'}
                >
                    <span className="pl-1">{t("offers.label")}</span>
                    <ChevronDownIcon
                        className={`${open ? '' : 'text-opacity-70'}
                        ml-2 h-5 w-5 group-hover:text-opacity-80 transition ease-in-out duration-150`}
                        aria-hidden="true"
                    />
                </Popover.Button>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                >
                    <Popover.Panel className="absolute z-10 w-screen max-w-sm px-4 mt-3 transform -translate-x-1/2 left-1/2 sm:px-0">
                        <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                            <div className="relative grid gap-8 bg-white p-7 lg:grid-cols-1">
                                <NavLink to="doctorados/teaching-assistant" onClick = {() => popover.current?.click()} className={({isActive}) => 
                                    "text-base font-medium " + (!isActive ? "text-gray-500 hover:text-slate-900" : "text-slate-900")
                                }>{t("offers.teaching.label")}</NavLink>
                                <NavLink to="doctorados/research-assistant" onClick = {() => popover.current?.click()} className={({isActive}) => 
                                    "text-base font-medium " + (!isActive ? "text-gray-500 hover:text-slate-900" : "text-slate-900")
                                }>{t("offers.research.label")}</NavLink>
                            </div>
                        </div>
                    </Popover.Panel>
                </Transition>
            </>
            )}
        </Popover>
    )
}

export default Menu_Popover;